import PropTypes from 'prop-types'
import styled from 'styled-components'

const StyledColorCircle = styled.div`
  background: ${props => props.color};
  border-radius: 5px;
  width: 8px;
  height: 8px;
  margin-right: 4px;
`

const ColorCircle = ({ color }) => {
  return (
    <StyledColorCircle color={color} data-test='color-circle' />
  )
}

ColorCircle.propTypes = {
  color: PropTypes.string.isRequired,
}

export default ColorCircle
